import constant from "../main.constants";

export const loadComponent = (componentKey) => {
  const validKeys = Object.values(constant.ENV_COMPONENTS);

  if (!validKeys.includes(componentKey)) {
    console.warn(`Component key "${componentKey}" geçersiz.`);
    return null;
  }

  const componentName = constant.ENV_COMPONENT_MAPPING[componentKey];

  if (!componentName) {
    console.warn(`Component key "${componentKey}" için mapping bulunamadı.`);
    return null;
  }

  switch (componentName) {
    case "WATERMARK":
      if (process.env.VUE_APP_ENVIRONMENT === "Jandarma") {
        return import("@/components/env-separate/app-components/WaterMark.vue");
      }
      return null;

    case "ANNOUNCEMENTS":
      if (process.env.VUE_APP_ENVIRONMENT === "Jandarma") {
        return import("@/views/Announcements.vue");
      }
      return null;

    case "PARSNOTITLELOGO":
      if (process.env.VUE_APP_ENVIRONMENT === "Jandarma") {
        return import("@/components/env-separate/boverlay-components/ParsNoTitleLogo.vue");
      }
      return null;

    //TODO -> Jandarma olmayan environment case'leride buraya gelebilir.

    default:
      console.warn(`Component "${componentName}" için loader tanımlı değil.`);
      return null;
  }
};

export const loadAsset = (assetKey) => {
  const validKeys = Object.values(constant.ENV_ASSETS);

  if (!validKeys.includes(assetKey)) {
    console.warn(`Asset key "${assetKey}" geçersiz.`);
    return null;
  }

  const assetName = constant.ENV_ASSET_MAPPING[assetKey];

  if (!assetName) {
    console.warn(`Asset key "${assetKey}" için mapping bulunamadı.`);
    return null;
  }

  switch (assetName) {
    case "PARS_LOGO":
      switch (process.env.VUE_APP_ENVIRONMENT) {
        case 'Jandarma':
          return require("@/assets/images/PARS.png");
        case 'Gumruk':
          return require("@/assets/images/UMUT.png");
        default:
          return require("@/assets/images/datateam_small_logo.png");
      }

    case "BG_WATERMARK":
      if (process.env.VUE_APP_ENVIRONMENT === "Jandarma") {
        return require("@/assets/images/parsBlueEyeNoBg.png");
      }
      return null;

    default:
      console.warn(`Asset "${assetName}" için loader tanımlı değil.`);
      return null;
  }
};

export const loadTheme = () => {
  let themeKey;
  switch (process.env.VUE_APP_ENVIRONMENT) {
    case 'Jandarma':
      themeKey = 'jandarma';
      break;
    default:
      themeKey = 'banka';
  }

  const theme = constant.THEMES[themeKey];
  if (!theme) return;

  const root = document.documentElement;
  Object.entries(theme).forEach(([key, value]) => {
    root.style.setProperty(`--theme-${key}`, value);
  });
};

export const loadAssetClass = (classKey) => {
  const validKeys = Object.values(constant.ENV_ASSETS_CLASSES);

  if (!validKeys.includes(classKey)) {
    console.warn(`Class key "${classKey}" geçersiz.`);
    return "";
  }

  const className = constant.ENV_ASSETS_CLASSES_MAPPING[classKey];

  if (!className) {
    console.warn(`Class key "${classKey}" için mapping bulunamadı.`);
    return "";
  }

  switch (className) {
    case "PARS_LOGO":
      if (process.env.VUE_APP_ENVIRONMENT === "Jandarma") {
        return "pars-logo";
      }
      else if (process.env.VUE_APP_ENVIRONMENT === "Gumruk") {
        return "umut-logo";
      }
      return "datactive-logo";

    default:
      console.warn(`Class "${className}" için loader tanımlı değil.`);
      return "";
  }
};